export const CALCULATE_START = "CALCULATE_START";
export const CALCULATE_SUCCESS = "CALCULATE_SUCCESS";
export const CALCULATE_FAIL = "CALCULATE_FAIL";

export const CALCULATE_SHOW_MODAL = "CALCULATE_SHOW_MODAL";
export const CALCULATE_HIDE_MODAL = "CALCULATE_HIDE_MODAL";

export const SEASONAL_INFO_SHOW_MODAL = "SEASONAL_INFO_SHOW_MODAL";
export const SEASONAL_INFO_HIDE_MODAL = "SEASONAL_INFO_HIDE_MODAL";
